export enum Constants {
    ADD_ACCOUNT = 'ADD_ACCOUNT',
    SET_ACCOUNTS = 'SET_ACCOUNTS',
    UPDATE_ACCOUNT = 'UPDATE_ACCOUNT',
    REMOVE_ACCOUNTS = 'REMOVE_ACCOUNTS'
}
